import { render } from "./VisionVentureHome.vue?vue&type=template&id=795332e2&scoped=true"
import script from "./VisionVentureHome.vue?vue&type=script&lang=js"
export * from "./VisionVentureHome.vue?vue&type=script&lang=js"

import "./VisionVentureHome.vue?vue&type=style&index=0&id=795332e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795332e2"]])

export default __exports__